import {
  // removeNullAttributes,
  // queryStringFromObject,
  authHeader,
  handleResponse,
} from "../_helpers";

const BASE_URL = process.env.REACT_APP_BASE_URL;

// All vs2jen2Limited Releases List
function getVs2jen2LimitedReleasesList() {
  // arg : queryParams
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
  };
  // const { sortOrder, sortBy } = { ...queryParams };
  // delete queryParams.sortOrder;
  // delete queryParams.sortBy;

  // const sortQuery =
  //   sortOrder && sortBy
  //     ? `&sort=${
  //         sortBy === "uploadedDate" ? "uploadedDateInMillis" : sortBy
  //       }:${sortOrder}`
  //     : "";

  // const queryObject = removeNullAttributes(queryParams);
  // const query = queryStringFromObject(queryObject);

  const endPoint = `/api/admin/v1/releases/analyzers/vs2jen2/limited`; //?${query}${sortQuery}

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
}

export const vs2jen2LimitedReleasesListService = {
  getVs2jen2LimitedReleasesList,
};
